import { defineComponent as _defineComponent } from 'vue'
import BButton from '../BButton.vue';
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CarouselTrackingService from 'JS/services/CarouselTrackingService';
import Icon from '../Icon.vue';
import ProductListPrice from 'JS/catalog/components/product-list/price/ProductListPrice.vue';
import ProductService, { AddToCartResult, IPDPAddToCartResponse } from 'JS/services/ProductService';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { createCarouselClickData, createCarouselClickGtmData } from 'JS/utilities/carousel-tracking';
import { FulfillmentType } from 'JS/types/ProductDelivery';
import { getPriceMode } from 'JS/types/Product';
import { IProductCarousel, IProductCarouselProduct } from 'JS/types/Carousel';
import { IQuickCartSummaryJson } from 'JS/types/Order';
import { onMounted, ref } from 'vue';
import { useProductCarouselTracking } from 'JS/dxp/composables/product-carousel-tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyItAgainCarousel',
  props: {
    carousel: null
  },
  setup(__props: any) {

const props = __props as {
	carousel: IProductCarousel;
}



const _trackingSvc = new CarouselTrackingService();
const productService = new ProductService();

const addedProducts = ref<string[]>([]);
const productLoading = ref<string[]>([]);
const productAddError = ref<string[]>([]);

//TODO: Make sure this doesn't remove anything we want to keep. Used to get rid of "Today's Price" and Was price.
function removePriceText(price) {
	return { ...price, pricePromoText: null, hideWasPrice: true };
}

///////GA Tracking///////
const intersectionObserverOptions = {
	root: null,
	rootMargin: '-150px', //Trigger once 150px of the carousel is in view
};

const { trackView, trackClick } = useProductCarouselTracking(() => ({
	type: props.carousel.carouselType,
	name: props.carousel.name,
	products: props.carousel.products.map(product => ({
		blainNumber: product.blainNumber,
		vendorBrand: product.vendorBrand,
		productName: product.name,
		price: product.price,
		belowMap: product.price.isBelowMAP,
		priceMode: getPriceMode(product.price)
	}))
}));

function trackClickHelper(product: IProductCarouselProduct) {
	const viewImpressionUrl = (window.location.pathname + window.location.search);

	const clickData = createCarouselClickData(
		product,
		props.carousel,
		null,
		viewImpressionUrl
	);

	const gtmData = createCarouselClickGtmData(product, props.carousel);

	_trackingSvc.trackClick(clickData, gtmData); //Track 'carousel' clickthrough
}

function productAdded(product: IProductCarouselProduct) {
	return addedProducts.value.includes(product.blainNumber);
}

function productHasError(product: IProductCarouselProduct) {
	return productAddError.value.includes(product.blainNumber);
}

async function addToCart(product: IProductCarouselProduct): Promise<void> {
	productLoading.value.push(product.blainNumber);

	trackClickHelper(product);

	const fulfillment: FulfillmentType = await productService.getProductLastFulfillmentType(product.blainNumber);

	const response: IPDPAddToCartResponse = await productService.addToCart({
		blainNumber: product.blainNumber,
		qty: 1,
		userConfirmed: true,
		userAgreed: false, // quick add products should not have a product agreement in the first place
		updateSubscriptionRequest: null,
		skipUpsell: true,
		ignoreFulfillmentType: true,
		fulfillmentType: fulfillment,
	});

	addToCartResponse(response, product);
}


function addToCartResponse(res: IPDPAddToCartResponse, product: IProductCarouselProduct): void {
	if (res?.result != AddToCartResult.Success) {
		productAddError.value.push(product.blainNumber);
	} else  {
		updateHeader(res.cartSummary);
		addedProducts.value.push(product.blainNumber);
		productAddError.value = productAddError.value.filter((sku)=> {
			return sku !== product.blainNumber;
		});

		const cartProduct = res.cartSummary.productsInCart.find(cartProduct => cartProduct.blainNumber === product.blainNumber);
		// Add to Cart event for Google Tag Manager
		const orderProducts = res.cartSummary.productsInCart.map(item => ({
			blainNumber: item.price.blainNumber,
			qty: item.qty,
			unitPrice: item.price.price,
			vendorBrand: item.vendorBrand,
			productName: item.productName,
			imageUrl: item.imageUrlLarger,
			productUrl: item.virtualURL
		}));

		window.blainGtmDataLayer.push({ orderProducts: null }); // orderProducts needs to be reset first to avoid conflicts
		window.blainGtmDataLayer.push({
			'blainNumber': product.blainNumber,
			'vendorBrand': product.vendorBrand,
			'productName': product.productName,
			'deliveryChannel': FulfillmentType.StandardShipping,
			'totalValue': cartProduct.unitPrice,
			'qty': 1,
			'orderProducts': orderProducts,
			'orderId': res.orderID,
			'event': "cart_ajax_add"
		});
	}

	productLoading.value = productLoading.value.filter((sku)=> {
		return sku !== product.blainNumber;
	});

}

function updateHeader(cartSummary: IQuickCartSummaryJson): void {
	if (window.vueEventBus && cartSummary) {
		window.vueEventBus.$emit('update-quick-cart', cartSummary);
	}
}

onMounted(() => {
	//Prevents infinite loading when using the back button in safari.
	window.addEventListener( "pageshow", function ( event ) {
		if ( event.persisted ) {
			productLoading.value = [];
		}
	});
});


return { __sfc: true,props, _trackingSvc, productService, addedProducts, productLoading, productAddError, removePriceText, intersectionObserverOptions, trackView, trackClick, trackClickHelper, productAdded, productHasError, addToCart, addToCartResponse, updateHeader, BButton, CarouselArrowButton, Icon, ProductListPrice, VIntersectionObserver }
}

})